function NotNullFieldFootnote(props) {
  return (
    <small style={{ color: "gray", margin: "20px 25px 0px 25px" }}>
      * field cannot be empty
    </small>
  );
}

export default NotNullFieldFootnote;
